import { render, staticRenderFns } from "./ReferenceCategories.vue?vue&type=template&id=9f05f95e&scoped=true&"
import script from "./ReferenceCategories.vue?vue&type=script&lang=ts&"
export * from "./ReferenceCategories.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceCategories.vue?vue&type=style&index=0&id=9f05f95e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f05f95e",
  null
  
)

export default component.exports